import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getClubBySlug } from '../utils/clubs';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/App.css';
import HeroImage from '../assets/images/HeroCoach.png';

function ClubLanding() {
  const { slug } = useParams();
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setError('No club specified');
      return;
    }
    getClubBySlug(slug)
      .then((c) => {
        setClub(c);
        setError(!c ? 'Club not found' : null);
      })
      .catch((err) => {
        console.error('[ClubLanding] Error:', err);
        setError('Could not load club');
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="home">
        <Header />
        <main style={{ padding: '80px 24px', textAlign: 'center', minHeight: '50vh' }}>
          <p>Loading...</p>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !club) {
    return (
      <div className="home">
        <Header />
        <main style={{ padding: '80px 24px', textAlign: 'center', minHeight: '50vh' }}>
          <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: '48px', marginBottom: '24px' }}>
            Club Not Found
          </h2>
          <p style={{ marginBottom: '32px' }}>{error || 'This club does not exist or has been removed.'}</p>
          <Link to="/clubs" className="c-ripple primary-button">View Club Program Info</Link>
        </main>
        <Footer />
      </div>
    );
  }

  const signupUrl = `/signup?club=${club.slug}`;
  const bannerImage = club.bannerUrl || HeroImage;
  const teamCount = club.teams?.length || 0;
  const ageGroups = [...new Set((club.teams || []).map((t) => t.ageGroup))];

  return (
    <div className="home">
      <SEO
        title={`Join ${club.name} | Begin Strength`}
        description={`Join ${club.name} for the Begin Strength Volleyball Program. Sign up to get started.`}
        path={`/clubs/${club.slug}`}
      />
      <Header />
      <main>
        <div className="hero" style={{ backgroundImage: `url(${bannerImage})` }}>
          <div className="hero-overlay">
            <div className="hero-content">
              {club.logoUrl && (
                <img
                  src={club.logoUrl}
                  alt={club.name}
                  style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', marginBottom: '16px', border: '2px solid rgba(255,255,255,0.2)' }}
                />
              )}
              <h2 className="hero-header">
                Join <span style={{ color: 'red' }}>{club.name}</span>
              </h2>
              <div className="hero-paragraph">
                <p>Sign up for the Begin Strength Volleyball Program through {club.name}.</p>
                <p>Get periodized strength training built for volleyball — vertical power, lateral explosion, and workouts that fit your schedule.</p>
              </div>
              <div className="hero-buttons">
                <Link to={signupUrl} className="c-ripple primary-button">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: '60px 24px', textAlign: 'center', maxWidth: '640px', margin: '0 auto' }}>
          {(teamCount > 0 || ageGroups.length > 0) && (
            <div style={{ marginBottom: '32px' }}>
              {ageGroups.length > 0 && (
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '16px', lineHeight: 1.6 }}>
                  Age groups: {ageGroups.join(', ')} &middot; {teamCount} team{teamCount !== 1 ? 's' : ''}
                </p>
              )}
            </div>
          )}

          <p style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            Already have an account? <Link to={`/signin?club=${club.slug}`} style={{ color: '#FF0000', textDecoration: 'underline' }}>Sign in</Link> to join this club.
          </p>
          <Link to="/clubs" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'underline', fontSize: '14px' }}>
            Learn more about the program
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ClubLanding;
